export var ClearSelectionDirective = [
    function () {
        return {
            link: function ($scope, $element, $attributes) {
                var mouseDownHandler = function ($event) {
                    if ('selection' in document) {
                        document.selection.empty();
                    }
                    else if ('getSelection' in window) {
                        window.getSelection().removeAllRanges();
                    }
                    $event.preventDefault();
                };
                $element.on('mousedown', mouseDownHandler);
                $scope.$on('$destroy', function () {
                    $element.off('mousedown', mouseDownHandler);
                });
            },
            restrict: 'A',
        };
    },
];
